<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      v-if="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="1200"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Bukti Temuan 

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-2">
          <ValidationObserver 
            ref="form">
            <v-form>

              <div class="mb-4 black--text">
                <table style="width: auto;">
                  <tr>
                    <td style="width: 120px; vertical-align: sub;">
                      Nama Kriteria
                    </td>
                    <td class="px-1" style="vertical-align: sub;">
                      :
                    </td>
                    <td class="px-2">
                      {{ name_kriteria }}
                    </td>
                  </tr>
                </table>
              </div>

              <div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3">
                <div class="mr-3">
                  <uploadimage
                    v-model="upload.image" >
                    <div 
                      slot="activator"
                      class="cursor-pointer">
                      <v-btn
                        color="#4B4B4B"
                        elevation="0"
                        small
                        :disabled="process.image"
                        :loading="process.image"
                        min-height="30"
                        class="fs-12 white--text text-capitalize d-flex align-center"
                        style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                        <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                        
                        <span
                          class="ml-2 ">
                          Tambah Gambar
                        </span>
                      </v-btn>
                    </div>
                  </uploadimage>
                </div>
                <div class="mr-3">
                  <uploaddocument
                    v-model="upload.document" >
                    <div 
                      slot="activator"
                      class="cursor-pointer">
                      <v-btn
                        color="primary"
                        elevation="0"
                        small
                        :disabled="process.document"
                        :loading="process.document"
                        min-height="30"
                        class="fs-12 white--text text-capitalize d-flex align-center"
                        style="border-radius: 6px; font-weight: 600;">
                        <v-icon size="15">mdi-file-document</v-icon>
                        
                        <span
                          class="ml-2 ">
                          Tambah File
                        </span>
                      </v-btn>
                    </div>
                  </uploaddocument>
                </div>
                <div class="mr-3">
                  <v-btn
                    color="#D81B60"
                    elevation="0"
                    small
                    @click="all_document.push({ date: '', name: '', doc: '', type: 'link' })"
                    min-height="30"
                    class="fs-12 white--text text-capitalize d-flex align-center"
                    style="border-radius: 6px; font-weight: 600;">
                    <v-icon size="15">mdi-link</v-icon>
                    
                    <span
                      class="ml-2 ">
                      Tambah Link
                    </span>
                  </v-btn>
                </div>
                <div class="mr-3">
                  <v-btn
                    color="#E65100"
                    elevation="0"
                    small
                    @click="all_document.push({ date: '', name: '', doc: '', type: 'agenda' })"
                    min-height="30"
                    class="fs-12 white--text text-capitalize d-flex align-center"
                    style="border-radius: 6px; font-weight: 600;">
                    <v-icon size="15">mdi-calendar-month-outline</v-icon>
                    
                    <span
                      class="ml-2 ">
                      Tambah Agenda
                    </span>
                  </v-btn>
                </div>
              </div>

              <div class="">
                <table style="border: 1px solid #ededed; width: 100%;">
                  <tr>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                      Aksi
                    </th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                      Link
                    </th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px;" class="black--text">
                      Tanggal
                    </th>
                    <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                      Keterangan
                    </th>
                  </tr>
                  <tr v-for="(item, index) in all_document" :key="index">
                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                      <v-tooltip 
                        top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="all_document.splice(index, 1)"
                            
                            v-bind="attrs"
                            v-on="on"
                            
                            min-width="24" min-height="24"
                            x-small
                            rounded
                            color="red"
                            elevation="0"
                            class="white--text text-capitalize mx-1 px-0"
                            style="font-weight: 600; border-radius: 6px;">
                            <v-icon size="15">mdi-trash-can-outline</v-icon>
                          </v-btn>
                        </template>

                        <span>Hapus</span>
                      </v-tooltip>
                    </td>
                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 350px; min-width: 350px; max-width: 350px;" class="black--text">
                      <div v-if="item.type !== 'link' && item.type !== 'agenda'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :href="item.doc"
                              target="_blank"
                              
                              v-bind="attrs"
                              v-on="on"
                              
                              min-width="24" min-height="24"
                              x-small
                              rounded
                              :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                            </v-btn>
                          </template>
  
                          <span>Lihat</span>
                        </v-tooltip>
                      </div>
                      <div v-if="item.type === 'link'">
                        <ValidationProvider 
                          :name="`Link ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
  
                          <v-text-field
                            
                            filled
                            rounded
                            dense
                            type="text"
  
                            :color="set_color"
                            placeholder="Link"
  
                            hide-details
  
                            v-model="item.doc"
                            :success="item.doc !== '' && valid"
                            :error-messages="errors"
                            required
                            class="mb-0"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  {{ errors[0] }}
                                </v-tooltip>
                              </div>
  
                              <div v-if="item.doc !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </div>
                      <div v-if="item.type === 'agenda'">
                        <ValidationProvider 
                          :name="`Agenda ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
  
                          <v-autocomplete
                            
                            filled
                            rounded
                            dense
                            type="text"
  
                            :color="set_color"
                            placeholder="Agenda"
  
                            hide-details
                            :items="agenda"
                            item-text="title"
                            item-value="link"
  
                            v-model="item.doc"
                            :success="item.doc !== '' && valid"
                            :error-messages="errors"
                            required
                            class="mb-0"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  {{ errors[0] }}
                                </v-tooltip>
                              </div>
  
                              <div v-if="item.doc !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </div>
                    </td>
                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 200px;" class="black--text">
                      <ValidationProvider 
                        :name="`Tanggal ${index + 1}`" 
                        rules="required" 
                        v-slot="{ errors, valid }">
      
                        <v-text-field
                          
                          filled
                          rounded
                          dense
                          type="date"
      
                          :color="set_color"
                          placeholder="Tanggal"
      
                          hide-details
      
                          v-model="item.date"
                          :success="item.date !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-0"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
      
                            <div v-if="item.date !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </td>
                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                      
                      <div>
                        <ValidationProvider 
                          :name="`Keterangan ${index + 1}`" 
                          rules="required" 
                          v-slot="{ errors, valid }">
      
                          <v-textarea
                            
                            
                            filled
                            rounded
                            dense
                            rows="2"
      
                            :color="set_color"
                            placeholder="Keterangan"
      
                            hide-details
      
                            v-model="item.name"
                            :success="item.name !== '' && valid"
                            :error-messages="errors"
                            required
                            class="mb-0"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  {{ errors[0] }}
                                </v-tooltip>
                              </div>
      
                              <div v-if="item.name !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>

              <v-card-text
                v-if="all_document.length === 0"
                class="pb-0 mb-4" style="height: 250px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                <div class="text-center">
                  <div class="mt-3 fs-16">
                    Belum ada Data
                  </div>
                </div>
              </v-card-text>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form || all_document.length < 1"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <div class="mb-2">
              <div class="d-flex align-center" style="width: 100%;">
                <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;">
                  Pilih Data KPI Unit
                </div>
                <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                  :
                </div>
                <div style="font-size: 14px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 2px; text-align: left; width: calc(100% - 176px); min-width: calc(100% - 176px); max-width: calc(100% - 176px);">

                  <ValidationProvider 
                    :name="`Pilih Data KPI Unit`" 
                    :rules="`required`" 
                    v-slot="{ errors, valid }">
                    <v-autocomplete
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      :placeholder="`Pilih Data KPI Unit`"
                      :items="list_summary"
                      :item-text="item => `${item.unit_name} - ${item.date} - ${item.location} - ${item.penilai === '' ? '-' : item.penilai}`"
                      item-value="id"

                      hide-details
                      v-on:change="fetch()"

                      v-model="selected.id"
                      :success="selected.id !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-0 fs-12 little-placeholder-autocomplate"
                      style="border-radius: 6px; min-width: 100%;">
                      <template v-slot:selection="{ item }">
                        <div>
                          {{ item.unit_name }} - {{ item.date | date }} - {{ item.location }} - {{ item.penilai === '' ? 'Belum Ada Penilai' : item.penilai }}
                        </div>
                      </template>

                      <template v-slot:item="{ item }">
                        <div class="fs-12">
                          {{ item.unit_name }} - {{ item.date | date }} - {{ item.location }} - {{ item.penilai === '' ? 'Belum Ada Penilai' : item.penilai }}
                        </div>
                      </template>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </v-card-text>

          <div v-if="selected.id !== ''">
            <v-card-text
            v-if="process.load" 
            class="pb-0 my-4" 
            style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <div class="mb-4 title">
                Mohon Tunggu . . .
              </div>
  
              <v-progress-linear
                :color="set_color"
                indeterminate
                rounded
                height="10">
              </v-progress-linear>
            </div>
          </v-card-text>
  
          <div class="view" v-if="!process.load">
            <div :class="list.length < 1 ? '' : 'wrapper_penilaian'">
              <table style="border: 1px solid #ededed; width: 100%;" class="table">
                <tr>
                  <th class="sticky-col one-penilaian-col" style="font-size: 12px; z-index: 2;  border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">NOMOR</th>
                  <th class="sticky-col second-penilaian-col" style="font-size: 12px; z-index: 2; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" :style="`background-color: ${set_color};`">KRITERIA</th>
                  <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" :style="`background-color: ${set_color};`">BUKTI TEMUAN</th>
                  <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" :style="`background-color: ${set_color};`">KETERANGAN</th>
                  <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" :style="`background-color: ${set_color};`">SESUAI / TIDAK SESUAI</th>
                  <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 150px; min-width: 150px; max-width: 150px;" :style="`background-color: ${set_color};`">JENIS KETIDAKSESUAIAN</th>
                </tr>
                <tr v-for="(item, index) in list_parent" :key="index">
                  <td class="sticky-col one-penilaian-col" style="z-index: 1; font-size: 12px; border: 1px solid #ededed; width: 80px; min-width: 80px; max-width: 80px; padding: 8px 12px; text-align: right; background-color: #fff;" :style="item.num_children === 1 ? 'font-weight: 600; padding-left: 18px;' : item.num_children === 2 ? 'padding-left: 24px;' : 'font-weight: 700'">
                    {{ item.number }}
                  </td>
                  <td class="sticky-col second-penilaian-col" style="z-index: 1; font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" :style="item.num_children === 1 ? 'font-weight: 600; padding-left: 18px;' : item.num_children === 2 ? 'padding-left: 24px;' : 'font-weight: 700'">
                    <div class="d-flex align-center">
                      <v-btn
                        elevation="0"
                        style="border-radius: 6px;"
                        x-small
                        v-if="item.is_child"
                        :class="!item.is_show ? 'green' : 'red'"
                        class="text-capitalize font-weight-bold d-flex align-center white--text fs-10"
                        @click="item.is_show ? hide_child(item) : show_child(item)">
                        {{ item.is_show ? 'Tutup' : 'Buka' }}
                      </v-btn>
                      <div class="ml-2">
                        {{ item.kriteria }}
                        <div v-if="item.num_children === 2" class="fs-11 mt-2 grey--text text--darken-4 d-flex align-center">
                          <div>
                            Bobot Minor: {{ (item.bobot_minor*1) | number }} 
                          </div>
                          <div class="ml-2"> 
                            Bobot Mayor: {{ (item.bobot_mayor*1) | number }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="" style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left; width: 450px; min-width: 450px; max-width: 450px;">
                    <div v-if="item.num_children === 2">
                      <v-btn
                        elevation="0"
                        style="background: #4caf5033; border-radius: 6px;"
                        small
                        class="text-capitalize font-weight-bold d-flex align-center green--text"
                        @click="dialog.form = true; reset(item);">
                        <v-icon size="15">mdi-plus-circle-outline</v-icon>
                        <span class="ml-1" style="font-size: 12px;">
                          Tambah
                        </span>
                      </v-btn>

                      <div class="mt-2" v-if="item.bukti_json">

                        <table style="border: none; width: 100%;">
                          <tr>
                            <th style="font-size: 12px; border: 1px solid #ededed; color: white; border-left: none; border-right: none; border-top: none !important; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                              Link
                            </th>
                            <th style="font-size: 12px; border: 1px solid #ededed; color: white; border-left: none; border-right: none; border-top: none !important; padding: 8px 12px; text-align: left; width: 200px;" class="black--text">
                              Tanggal
                            </th>
                            <th style="font-size: 12px; border: 1px solid #ededed; color: white; border-left: none; border-right: none; border-top: none !important; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              Keterangan
                            </th>
                          </tr>
                          <tr v-for="(items, index) in item.bukti_json" :key="index">
                            <td style="font-size: 12px; border: 1px solid #ededed; color: white; border-left: none; border-bottom: none; border-right: none; border-top: none !important; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                              <div v-if="items.type !== 'link' && items.type !== 'agenda'">
                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      :href="items.doc"
                                      target="_blank"
                                      
                                      v-bind="attrs"
                                      v-on="on"
                                      
                                      min-width="24" min-height="24"
                                      x-small
                                      rounded
                                      :color="items.type === 'image' ? 'indigo' : items.type === 'pdf' ? '#b40c1d' : items.type === 'doc' || items.type === 'docx' ? '#1b58b8' : '#097640'"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="15">{{ items.type === 'image' ? 'mdi-image-area' : items.type === 'pdf' ? 'mdi-file-pdf' : items.type === 'doc' || items.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                    </v-btn>
                                  </template>
  
                                  <span>Lihat</span>
                                </v-tooltip>
                              </div>
                              <div v-if="items.type === 'link'">
                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      :href="items.doc"
                                      target="_blank"
                                      
                                      v-bind="attrs"
                                      v-on="on"
                                      
                                      min-width="24" min-height="24"
                                      x-small
                                      rounded
                                      :color="'#D81B60'"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="15">mdi-link</v-icon>
                                    </v-btn>
                                  </template>
  
                                  <span>Lihat</span>
                                </v-tooltip>
                              </div>
                              <div v-if="items.type === 'agenda'">
                                <v-tooltip 
                                  top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      :href="items.doc"
                                      target="_blank"
                                      
                                      v-bind="attrs"
                                      v-on="on"
                                      
                                      min-width="24" min-height="24"
                                      x-small
                                      rounded
                                      :color="'#E65100'"
                                      elevation="0"
                                      class="white--text text-capitalize mx-1 px-0"
                                      style="font-weight: 600; border-radius: 6px;">
                                      <v-icon size="15">mdi-calendar-month-outline</v-icon>
                                    </v-btn>
                                  </template>
  
                                  <span>Lihat</span>
                                </v-tooltip>
                              </div>
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; color: white; border-left: none; border-bottom: none; border-right: none; border-top: none !important; padding: 8px 12px; text-align: left; width: 120px; min-width: 120px;" class="black--text">
                              {{ items.date | date }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; color: white; border-left: none; border-bottom: none; border-right: none; border-top: none !important; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                              
                              <div>
                                {{ items.name }}
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </td>
                  <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left; width: 250px; min-width: 250px; max-width: 250px;">
                    <div v-if="item.num_children === 2">
                      <v-textarea
                        filled
                        rounded
                        dense
                        v-on:change="reset(item); save_desc();"
                        :color="set_color"
                        hide-details
                        placeholder="Keterangan"
                        v-model="item.desc"
                        style="border-radius: 10px; width: 100%;">
                      </v-textarea>
                    </div>
                  </td>
                  <td class="" style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left; width: 180px; min-width: 180px; max-width: 180px;">
                    <div v-if="item.num_children === 2">
                      {{ item.kesuaian === 'sesuai' ? 'Sesuai' : item.kesuaian === 'tidak sesuai' ? 'Tidak Sesuai' : '-' }}
                    </div>
                  </td>
                  <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left; width: 180px; min-width: 180px; max-width: 250px;">
                    <div v-if="item.num_children === 2">
                      {{ item.kesuaian_type === 'mayor' ? 'Mayor' : item.kesuaian_type === 'minor' ? 'Minor' : '-' }}
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <v-card-text
              v-if="list.length === 0"
              class="pb-0 my-4" style="height: calc( 100vh - 295px ); display: flex; align-items: center; justify-content: center;">
              <div class="text-center">
                <v-img 
                  class="mx-auto"
                  contain
                  alt="vuetify"
                  :width="90"
                  :height="90"
                  :src="require('@/assets/image/empty.png')">
                </v-img>
                <div class="mt-3 fs-16">
                  Belum ada data
                </div>
              </div>
            </v-card-text>
          </div>
  
          <!-- <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '274px' : '202px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value }">
              {{ rowFormat(header.format, value) }} 
            </template>
  
            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>
  
            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table> -->
  
          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination"/>
          </div>
          <div v-else>
            <v-card-text
              class="pb-0 my-4" style="height: calc( 100vh - 295px ); display: flex; align-items: center; justify-content: center;">
              <div class="text-center">
                <v-img 
                  class="mx-auto"
                  contain
                  alt="vuetify"
                  :width="90"
                  :height="90"
                  :src="require('@/assets/image/empty.png')">
                </v-img>
                <div class="mt-3 fs-16">
                  Silahkan pilih Summary Terlebih dahulu
                </div>
              </div>
            </v-card-text>
          </div>

          
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,
          form: false,
          delete: false,

          map: false
        },
        agenda: [],
        is_edit: false,
        search: '',
        selected: {
          row: [],
          freeze: [],
          delete: [],
          id: ''
        },
        upload: {
          image: null,
          document: null
        },
        file_import: {
          filename: '',
          fileuri: ''
        },
        list_summary: [],
        name_kriteria: '',
        id_kriteria: '',
        desc_kriteria: '',
        bobot_id: '',
        options: {},
        headers: [],
        list: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,
        list_parent: [],

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        markers: [],
        all_document: [],

        form: {
          id: '',
          name: '',
          date: '',
          file: ''
        },
        process: {
          load: false,
          form: false,
          delete: false,
          image: false,
          document: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/file.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      }
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
      'upload.image': {
          handler: function () {
            if (this.upload.image) {
              // this.form.request_file_object.type = 'image'
              this.message.error = ''
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                this.all_document.push({
                  name: '',
                  date: '',
                  doc: this.upload.image.fileuri,
                  type: 'image'
                })
  
                this.upload.image = null
  
                // this.form.request_file_object.url = this.upload.image.fileuri
              }
            }
          },
          deep: true
        },
        'upload.document': {
          handler: function () {
            if (this.upload.document) {
              // this.form.request_file_object.type = 'file'
              this.message.error = ''
              this.process.document = this.upload.document.process
              
              if (!this.process.document) {
                var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
                var extension = this.upload.document.fileuri.match(regexp);
                // CALLBACK FROM UPLOAD IMAGE
                this.all_document.push({
                  name: '',
                  date: '',
                  doc: this.upload.document.fileuri,
                  type: extension && extension[1]
                })
  
                this.upload.document = null
  
                // this.form.request_file_object.url = this.upload.document.fileuri
              }
            }
          },
          deep: true
        },
    },
    mounted () {
      this.fetchSummary()
      this.fetchAgenda()
    },
    methods: {
      async fetchSummary () {
        let params = {
          limit: 100000
        }

        this.list_summary = []

        await get('kpi_unit/summary/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list_summary.push({
                ... obj
              })
            })
          }
        })
      },
      async fetchAgenda () {
        let params = {
          limit: 100000
        }

        this.list_summary = []

        await get('admin/event/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.agenda = []
            res.results.data.map(obj => {
              this.agenda.push({
                ... obj,
                link: `https://hr.umb.amanata.co/event/${obj.id}`
              })
            })
          }
        })
      },
      show_child (item) {
        item.is_show = !item.is_show
        let total_index = 0
        this.list.map((data, index) => {
          if(data.id === item.id){
            data.is_show = true
          }
        })
        this.list_parent.map((data, index) => {
          if(data.id === item.id){
            total_index = index
          }
        })
        this.list.map((data, indexs) => {
          this.list_parent.map((parent, index) => {
            if(parent.id === item.id){
              if(data.par_id === item.id){
                this.list_parent.splice(total_index + 1, 0, data)
                total_index++
              }
            }
          })
        })
      },
      hide_child (item) {
        item.is_show = !item.is_show
        this.list.map((data, index) => {
          if(data.id === item.id){
            data.is_show = false
          }
        })
        if(item.num_children === 1){
          for (let i = 0; i < item.child.length; i++) {
            this.list_parent.map((data, index) => {
              if(data.par_id === item.id){
                data.is_show = false
                this.list_parent.splice(index, 1)
              }
            })
          }
        } else {
          for (let i = 0; i < item.child.length; i++) {
            if(item.child[i].child.length > 0){
              for (let j = 0; j < item.child[i].child.length; j++) {
                this.list_parent.map((data, index) => {
                  if(data.par_par_id === item.id){
                    data.is_show = false
                    this.list_parent.splice(index, 1)
                  }
                })
              }
            } else {
              this.list_parent.map((data, index) => {
                if(data.par_id === item.id){
                  data.is_show = false
                  this.list_parent.splice(index, 1)
                }
              })
            }
          }
        }
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (non_load) {
        this.process.load = non_load === undefined ? true : false

        let params = {
          id: this.selected.id,
        }


        await get('kpi_unit/summary/detail', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Kode',
                width: '150px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama',
                width: '400px',
                value: 'name',
                freeze: false,
                hide: false
              }
            ]
            
            if (non_load === undefined) {
              this.list = []
              this.list_parent = []
  
              res.results.kpi_unit_arr.map((item, index_par) => {
                this.list.push({
                  ...item,
                  num_children: 0,
                  is_child: item.child.length > 0 ? true : false,
                  is_show: false
                })
                this.list_parent.push({
                  ...item,
                  num_children: 0,
                  is_child: item.child.length > 0 ? true : false,
                  is_show: false
                })
                if(item.child.length > 0){
                  item.child.map((child, index) => {
                    if(child.child.length > 0){
                      this.list.push(
                        {
                          ...child,
                          num_children: 1,
                          is_child: true,
                          par_par_id: item.id,
                          is_show: false
                        }
                      )
                      child.child.map((child2, index2) => {
                        this.list.push(
                          {
                            ...child2,
                            num_children: 2,
                            is_child: false,
                            par_par_id: item.id,
                            is_show: false
                          }
                        )
                      })
                    } else {
                      this.list.push(
                        {
                          ...child,
                          num_children: 1,
                          is_child: false,
                          par_par_id: item.id,
                          is_show: false
                        }
                      )
                    }
                  }
                  )
                } 
              })
            } else {
              let list = []
              let list_parent = []
              res.results.kpi_unit_arr.map((item, index_par) => {
                list.push({
                  ...item,
                  num_children: 0,
                  is_child: item.child.length > 0 ? true : false,
                  is_show: false
                })
                list_parent.push({
                  ...item,
                  num_children: 0,
                  is_child: item.child.length > 0 ? true : false,
                  is_show: false
                })
                if(item.child.length > 0){
                  item.child.map((child, index) => {
                    if(child.child.length > 0){
                      list.push(
                        {
                          ...child,
                          num_children: 1,
                          is_child: true,
                          par_par_id: item.id,
                          is_show: false
                        }
                      )
                      child.child.map((child2, index2) => {
                        list.push(
                          {
                            ...child2,
                            num_children: 2,
                            is_child: false,
                            par_par_id: item.id,
                            is_show: false
                          }
                        )
                      })
                    } else {
                      list.push(
                        {
                          ...child,
                          num_children: 1,
                          is_child: false,
                          par_par_id: item.id,
                          is_show: false
                        }
                      )
                    }
                  }
                  )
                } 
              })
              list.map((data, index) => {
                data.is_show = this.list[index].is_show
              })
              this.list = list
              this.list.map((data, index) => {
                this.list_parent.map((parent, indexs) => {
                  if(data.id === parent.id){
                    parent.is_show = data.is_show
                    parent.bukti_json = data.bukti_json
                  }
                })
              })
            }
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.all_document = []
        if(item.bukti_json.length > 0){
          item.bukti_json.map((doc, index) => {
            this.all_document.push({
              name: doc.name,
              date: doc.date,
              doc: doc.doc,
              type: doc.type
            })
          })
        } else {
          this.all_document = []
        }
        this.name_kriteria = item.kriteria
        this.id_kriteria = item.id
        this.desc_kriteria = item.desc
        this.bobot_id = item.bobot_id

        this.process.form = false

        this.message.error = ''
        
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = 'kpi_unit/summary/save_bukti',
              form = {
                id: this.bobot_id,
                summary_id: this.selected.id,
                master_id: this.id_kriteria,
                bukti_json: this.all_document,
                desc: this.desc_kriteria
              }

          // SAVE TO REST API


          await post(url, {
            data: {
              bobot_id: this.bobot_id,
              summary_id: this.selected.id,
              master_id: this.id_kriteria,
              bukti_json: this.all_document,
              desc: this.desc_kriteria
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // this.reset()

              this.fetch('non_load')
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async save_desc () {
        this.message.error = ''

        const isValid = true

        if (isValid) {
          this.process.form = true

          let url = 'kpi_unit/summary/save_bukti',
              form = {
                id: this.bobot_id,
                summary_id: this.selected.id,
                master_id: this.id_kriteria,
                bukti_json: this.all_document,
                desc: this.desc_kriteria
              }

          // SAVE TO REST API


          await post(url, {
            data: {
              bobot_id: this.bobot_id,
              summary_id: this.selected.id,
              master_id: this.id_kriteria,
              bukti_json: this.all_document,
              desc: this.desc_kriteria
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // this.reset()

              this.fetch('non_load')
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('kpi_unit/master/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
  
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper_penilaian { 
  overflow-y: auto; 
  height: calc(100vh - 195px); 
} 
.wrapper_penilaian th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-penilaian-col {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  left: 0px;
}

.three-col {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
  left: 80px;
}

.second-penilaian-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 80px;
}
tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>